import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

interface CancelConfirmDialogProps {
  open: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
  continuePrompt?: string;
  cancelPrompt?: string;
  dialogContent?: string;
  dialogTitle?: string;
}

const CancelConfirmDialog: React.FC<CancelConfirmDialogProps> = ({
  open,
  onConfirm,
  onDismiss,
  continuePrompt = 'No, Continue Editing',
  cancelPrompt = 'Yes, Cancel',
  dialogContent = 'You have unsaved changes. Are you sure you want to cancel? All entered data will be lost.',
  dialogTitle = 'Cancel Order Creation?',
}) => {
  return (
    <Dialog open={open} onClose={onDismiss}>
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText>{dialogContent}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDismiss} color="primary">
          {continuePrompt}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          {cancelPrompt}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelConfirmDialog;
